<template>
	<div class="login-container">
		<div class="login-heading">
			<img
				src="/images/pronto/combined-shape.png"
				class="combined-shape-login"
			/>
			<div>{{ $t('onboarding_loginmethod_title') }}</div>
		</div>

		<div class="text-center card-heading white-font">
			{{ $t('onboarding_supported_browsers') }}
		</div>
	</div>
</template>

<style lang="scss" scoped>
.login-container {
	width: 100%;
	height: 100vh;
	overflow-y: scroll;
}

.login-heading {
	padding-top: 100px;
	font-family: Avenir-Medium;
	font-size: 46px;
	text-align: center;
	color: #ffffff;
	font-weight: 300;
}
.card-heading {
	font-family: Avenir-Roman;
	font-size: 28px;
	color: #4f5053;
	margin-bottom: 20px;
	text-align: center;
}
</style>
